import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { createVuetify } from 'vuetify'
import { aliases, md } from 'vuetify/iconsets/md'
// must come before 'vuetify/styles': declares the CSS layer order and loads Bootstrap below Vuetify
import './assets/css/vuetify-layers.css'
import 'vuetify/styles'
import App from './App.vue'
import { i18n } from './i18n'
// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
// router setup
import routes from './routes/routes'
import authz from './middlewares/authz'

import Log from './services/log'

window.addEventListener('unhandledrejection', (event) => {
  if (Array.isArray(event.reason)) {
    event.preventDefault();
  }
});

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: 'nav-item active',
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash };
    }
    return { top: 0, left: 0 };
  }
});

router.beforeEach(authz());

const vuetify = createVuetify({
  // Vuetify 4 lowered the default breakpoints; keep the Vuetify 3 ones so layouts don't shift
  display: {
    thresholds: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920, xxl: 2560 }
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: { md }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976d2'
        }
      }
    }
  }
});

const app = createApp(App);

Log.setup(app);
app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(LightBootstrap);
app.mount('#app');

window.mainApp = app;
